import { useState } from "react";

export const SelectRegion = () => {
  const [range, setRange] = useState<[number, number]>([0, 493]);

  return {
    range,
    setRange,
  };
};
